import { Component } from '@angular/core';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { BookUploadService } from '../../shared/services/apis/platform/book-upload.service';
import { AgreementStruct, UploadLivroRequest } from '../../shared/services/requests/platform/upload-livro.request';
import { UploadLivroResponse } from '../../shared/services/responses/platform/upload-livro.response';
import { MenuComponent } from '../../shared/components/menu/menu.component';
import { CommonModule } from '@angular/common';
import { AgreementModalComponent } from '../agreement-modal/agreement-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { StatusVersionEnum } from '../../shared/services/enums/status-version.enum';
import { AlertService, AlertType } from '../../shared/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginValidationComponent } from '../login-validation.component/login-validation.component';
import { BookPaymentServiceService } from '../../shared/services/apis/platform/book-payment-service.service';
import { BookPaymentServiceRequest } from '../../shared/services/requests/platform/book-payment-service.request';
import { BookPaymentServiceItemStruct } from '../../shared/services/structs/book-payment-service-item.struct';
import { MatIcon } from '@angular/material/icon';
import { HireFormatterModalComponent } from '../hire-formatter-modal/hire-formatter-modal.component';
import { BookVersionService } from '../../shared/services/apis/platform/book-version.service';
import { BookVersionResponse, BookVersionStruct } from '../../shared/services/responses/platform/book-version.response';
import { FormGroup } from '@angular/forms';
import { RedirectService } from '../../redirect-service';

@Component({
    selector: 'app-book-upload',
    standalone: true,
    imports: [CommonModule, MenuComponent, FooterComponent, LoginValidationComponent, MatIcon],
    templateUrl: './book-upload.component.html',
    styleUrls: ['./book-upload.component.css']
})
export class BookUploadComponent {
    selectedFile: File | null = null;
    isUploading = false;
    uploadSuccess = false;
    errorMessage = '';
    formatterService = false;
    private lastFileFingerprint: string | null = null;
    bookVerifyNotes: string[] = [];
    canContinue = true;
    idBookVersion: number | null = null;
    bookVersion: BookVersionStruct | null = null;
    public isLoading: boolean = false;
    public model: FormGroup;
    reselectedSameFile = false;

    fileErrorCount: number = 0;

    constructor(
        private bookUploadService: BookUploadService,
        private alertService: AlertService,
        private route: ActivatedRoute,
        private redirectService: RedirectService,
        private bookVersionService: BookVersionService,
        private router: Router,
        private dialog: MatDialog) { }



    ngOnInit(): void {
        this.idBookVersion = Number(this.route.snapshot.paramMap.get('idBookVersion'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    onLoginValidated(isLogged: boolean) {
        if (!isLogged) {
            return;
        }
        if (!this.idBookVersion) {
            return;
        }
        else {
            this.getBookVersion();
        }
    }

    getBookVersion(): void {
        this.bookVersionService.GetBookVersion(this.idBookVersion as number, StatusVersionEnum.Material).subscribe({
            next: (res: BookVersionResponse) => {
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    return;
                }

                this.redirectService.redirectByStatus(res.bookVersionStruct.idStatusVersion, this.idBookVersion as number, res.bookVersionStruct.isCreditReviewing);

                this.bookVersion = res.bookVersionStruct;
                this.isLoading = false;
            },
            error: err => {
                this.alertService.show('Erro inesperado', err, AlertType.error);
                this.isLoading = false;
            }
        });
    }

    hireFormatter(): void {
        const dialogRef = this.dialog.open(HireFormatterModalComponent, { data: this.idBookVersion });
        dialogRef.afterClosed().subscribe((contratou: boolean) => {
            if (contratou) {
                this.formatterService = true;
                this.canContinue = true;
            } else {
                this.formatterService = false;
            }
        });
    }

    get canProceed(): boolean {
        return !!this.selectedFile && (!this.bookVerifyNotes.length || this.formatterService);
    }

    async upload(): Promise<void> {
        if (!this.selectedFile) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.isLoading = true;

        // // 1. Abrir o modal antes do upload
        // const dialogRef = this.dialog.open(AgreementModalComponent, {
        //     width: '90%',
        //     maxHeight: '90vh',
        //     data: StatusVersionEnum.Upload
        // });

        // const acceptedAgreements: AgreementStruct[] | null = await dialogRef.afterClosed().toPromise();

        // // 2. Cancelado ou não aceitou
        // if (!acceptedAgreements) {
        //     this.errorMessage = 'Você precisa aceitar os termos obrigatórios para continuar.';
        //     return;
        // }

        this.errorMessage = '';

        const base64File = await this.fileToBase64(this.selectedFile);

        const request = new UploadLivroRequest();
        if (this.idBookVersion) {
            request.idBookVersion = this.idBookVersion;
        }
        request.fileName = this.selectedFile.name;
        request.base64File = base64File;
        request.listAgreementStruct = new Array<AgreementStruct>();

        this.isUploading = true;

        this.bookUploadService.upload(request).subscribe({
            next: (res: UploadLivroResponse) => {
                if (res.isError) {
                    this.alertService.show('Erro', res.errorDescription, AlertType.error);
                    if (res.bookVerifyStruct?.notes) {
                        this.bookVerifyNotes = res.bookVerifyStruct.notes;
                        this.idBookVersion = res.idBookVersion;
                    }
                    this.isUploading = false;
                    this.canContinue = false;
                    this.isLoading = true;
                    return;
                }
                this.uploadSuccess = !res.isError;
                this.errorMessage = res.errorDescription || '';
                this.isUploading = false;
                this.bookVerifyNotes = res.bookVerifyStruct?.notes || [];
                
                this.canContinue = this.bookVerifyNotes.length === 0 || this.formatterService || true;

                const paymentRequest = new BookPaymentServiceRequest();
                paymentRequest.idBookVersion = res.idBookVersion;

                this.alertService.show('Sucesso', 'Arquivo enviado!', AlertType.success);

                // ************TODO: REMOVER `true` APÓS INSERÇAO INICIAL DE LIVROS *************
                if (this.bookVerifyNotes.length === 0 || this.formatterService || true) 
                    this.router.navigate(['/livro-capa', res.idBookVersion]);
                // ************TODO: REMOVER `true` APÓS INSERÇAO INICIAL DE LIVROS *************

                this.isLoading = true;
            },
            error: error => {
                this.alertService.show('Erro inesperado', error, AlertType.error);
                this.errorMessage = 'Erro ao enviar o arquivo.';
                this.fileErrorCount += 1;
                this.isUploading = false;
                this.isLoading = false;
            }
        });
    }

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result as string;
                resolve(result.split(',')[1]); // remove data:...;base64,
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
    }

    onFileDrop(event: DragEvent): void {
        event.preventDefault();
        const file = event.dataTransfer?.files[0];
        if (file) {
            this.validateAndSetFile(file);
        }
    }

    onFileSelected(event: Event): void {
        const target = event.target as HTMLInputElement;
        const file = target.files?.[0];
        if (file) {
            this.validateAndSetFile(file);
        }
    }

    private validateAndSetFile(file: File): void {
        const fileFingerprint = `${file.lastModified}-${file.size}`;

        const isSameFile = this.lastFileFingerprint === fileFingerprint;
        this.reselectedSameFile = false;

        if (file.size <= 50 * 1024 * 1024) {
            if (isSameFile) {
                this.reselectedSameFile = true;
                this.errorMessage = 'O mesmo arquivo foi selecionado novamente. Nenhuma alteração detectada.';
                this.fileErrorCount += 1;
                return;
            }
            //verificar se o formato é docx ou doc e informar erro se não for
            const allowedExtensions = ['doc', 'docx', 'DOC', 'DOCX'];
            const fileExtension = file.name.split('.').pop()?.toLowerCase();
            if (!fileExtension || !allowedExtensions.includes(fileExtension)) {
                this.errorMessage = 'Formato de arquivo inválido. Por favor, selecione um arquivo .doc ou .docx.';
                this.selectedFile = null;
                this.canContinue = false;
                // this.fileErrorCount += 1;
                return;
            }

            this.selectedFile = file;
            this.errorMessage = '';
            this.formatterService = false;
            this.bookVerifyNotes = [];
            this.canContinue = true;
            this.lastFileFingerprint = fileFingerprint;
        } else {
            this.errorMessage = 'Arquivo maior que 250MB.';
            this.fileErrorCount += 1;
            this.selectedFile = null;
            this.canContinue = false;
        }
    }
}
